export default {
  methods: {
    openRouteInNewTab(routeObject) {
      const {href} = this.$router.resolve(routeObject);
      window.open(href, '_blank');
    }
  }
}